import { CalendarDate } from '@internationalized/date';
import { useDateFormatter } from '@react-aria/i18n';

import Button from '../../../Button/Button';
import Row from '../../../Row/Row';
import PrevNextButton from '../PrevNextButton/PrevNextButton';

import styles from './YearSlider.module.css';

type YearSliderProps = {
    focusDate: CalendarDate;
    onChange: (focusDate: CalendarDate) => void;
    timeZone: string;
    minValue?: CalendarDate;
    maxValue?: CalendarDate;
};

const YearSlider = ({
    focusDate,
    timeZone,
    onChange,
    minValue,
    maxValue,
}: YearSliderProps) => {
    const formatter = useDateFormatter({
        year: 'numeric',
        timeZone: timeZone,
    });

    const previousYear = focusDate.add({ years: -1 });
    const nextYear = focusDate.add({ years: 1 });
    const years = [previousYear, focusDate, nextYear];

    return (
        <Row vertical="middle" space="small">
            <PrevNextButton
                direction="previous"
                onPress={() => onChange(previousYear)}
                isDisabled={minValue && previousYear.compare(minValue) < 0}
            />

            <Row flex space="small">
                {years.map((year, i) => (
                    <Button
                        key={i}
                        className={styles.YearButton}
                        size="small"
                        disabled={
                            (minValue && year.year < minValue.year) ||
                            (maxValue && year.year > maxValue.year)
                        }
                        onClick={() => onChange(year)}
                        variant={
                            year.compare(focusDate) === 0 ? 'brand' : 'white'
                        }
                    >
                        {formatter.format(year.toDate(timeZone))}
                    </Button>
                ))}
            </Row>

            <PrevNextButton
                direction="next"
                onPress={() => onChange(nextYear)}
                isDisabled={maxValue && nextYear.compare(maxValue) > 0}
            />
        </Row>
    );
};

export default YearSlider;
